var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjectif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.727,
    height: 29.325,
    viewBox: "651 22.001 36.727 29.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1865"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1843",
    transform: "translate(651 22)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.875 21.502a.862.862 0 0 0-.796-.533H24.39a.857.857 0 0 0 .245-.986L21.9 13.35a.862.862 0 0 0-.796-.534h-5.48a.862.862 0 0 0-.796.534l-2.737 6.633a.858.858 0 0 0 .245.986H8.648a.862.862 0 0 0-.796.533l-2.737 6.633a.862.862 0 0 0 .797 1.19h10.951a.862.862 0 0 0 .798-1.19l-2.737-6.633a.855.855 0 0 0-.253-.329h7.384a.847.847 0 0 0-.252.33l-2.737 6.632a.862.862 0 0 0 .797 1.19h10.952a.862.862 0 0 0 .797-1.19l-2.737-6.633ZM16.2 14.541h4.325l2.026 4.908h-8.376l2.025-4.908Zm-.625 13.06H7.2l2.025-4.908h4.325l2.025 4.908Zm5.576 0 2.025-4.908h4.325l2.026 4.908H21.15Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.363 6.46a.862.862 0 0 0 .862-.862V.862a.862.862 0 0 0-1.724 0v4.736c0 .476.386.862.862.862",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.26 6.825a.864.864 0 0 0 1.106.516.863.863 0 0 0 .516-1.105l-1.62-4.45a.861.861 0 1 0-1.62.59l1.619 4.45Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.757 9.772a.86.86 0 0 0 1.214.107.862.862 0 0 0 .106-1.215L6.033 5.037a.862.862 0 0 0-1.32 1.107l3.044 3.628Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 13.765a.862.862 0 0 0-.315-1.178L1.293 10.22a.862.862 0 0 0-.862 1.493l4.102 2.367a.862.862 0 0 0 1.178-.316",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.611 10.535a.861.861 0 0 0-1.177-.315l-4.101 2.367a.862.862 0 1 0 .862 1.493l4.1-2.367a.862.862 0 0 0 .316-1.178",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.31 10.08a.86.86 0 0 0 .66-.308l3.044-3.628a.862.862 0 1 0-1.322-1.107L27.65 8.663a.862.862 0 0 0 .66 1.416",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.36 7.34a.863.863 0 0 0 1.105-.515l1.62-4.449a.862.862 0 0 0-1.62-.59l-1.619 4.45a.862.862 0 0 0 .515 1.105",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6759"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36.727v29.325H0V0z",
    "data-name": "Rectangle 1500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectif);
export default __webpack_public_path__ + "static/media/objectif.ac1d510603a28e4559cba62979b5c2f2.svg";
export { ForwardRef as ReactComponent };